import React from "react";

const DataItem = ({ label, value }) => {
  return (
    <li className="data-item">
      <div className="data-col">
        {label && <div className="data-label">{label}</div>}
        <div className="data-value">{value}</div>
      </div>
    </li>
  );
};

export default DataItem;
